import { createTable } from "./helpers";

export default function calculate(inputValues, currency) {
  const currencyObj = { style: "currency", currency: currency?.code || "USD" };
  const locale = currency?.locale || "en-US";
  const totalLoan = +inputValues[0] + +inputValues[1] - +inputValues[2] - +inputValues[3] + +inputValues[7];
  const term = +inputValues[4];
  const nominal = +inputValues[5] / 100 / 12;
  const monthlyFee = +inputValues[8];

  // Future Value Annuities
  const balloon = (+inputValues[6] / 100) * totalLoan;
  const reduction = (balloon * nominal) / ((1 + nominal) ** term - 1);

  // Present Value Annuities
  // const monthlyInstalment = (totalLoan * nominal) / (1 - (1 + nominal) ** -term) - reduction + monthlyFee;
  const monthlyInstalment = (totalLoan * nominal) / (1 - (1 + nominal) ** -term) - reduction;
  const totalPaid = monthlyInstalment * term;
  const interestPaid = balloon + totalPaid - totalLoan;

  let msg;
  if (balloon > 0) {
    msg = `Take note that after paying all instalments, you will have to pay the residual amount of ${balloon.toLocaleString(
      locale,
      currencyObj,
    )}.`;
  }

  const instalment = monthlyInstalment.toLocaleString(locale, currencyObj);
  const loan = totalLoan.toLocaleString(locale, currencyObj);
  const interestPaid2 = interestPaid.toLocaleString(locale, currencyObj);
  const totalPaid2 = (totalPaid + monthlyFee * term + balloon).toLocaleString(locale, currencyObj);
  const balloon2 = balloon.toLocaleString(locale, currencyObj);

  const unmodResults = { term, instalment: monthlyInstalment, loan: totalLoan, nominal, rate: +inputValues[5] };

  const table = createTable(unmodResults);

  return {
    instalment,
    loan,
    interestPaid: interestPaid2,
    interest: interestPaid,
    totalPaid: totalPaid2,
    fees: (monthlyFee * term).toLocaleString(locale, currencyObj),
    nominal,
    term,
    unmodResults,
    table,
    totalLoan,
    balloon: balloon2,
    msg,
  };
  // return { instalment, loan, interestPaid: interestPaid2, totalPaid: totalPaid2, balloon: balloon2, msg };
}
